import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RegisterPage as RegisterPageView } from '../features/registration';
import { useAuth } from '../contexts/AuthContext';
import { getAccessToken } from '../lib/tokenStore';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect already-logged-in users away from the registration page
    const token = getAccessToken();
    if (token && user) {
      navigate(user?.role === 'student' ? '/dashboard' : '/feed');
    }
  }, [navigate, user]);

  return <RegisterPageView />;
};

export default RegisterPage;
